import { useLocation, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Menu, ChevronRight } from "lucide-react";
import { useAuthStore } from "../../store/authStore";

/**
 * Compact top bar for the platform admin shell. Shows a small breadcrumb of
 * the current section + a hamburger to open the sidebar on mobile.
 */
export default function PlatformTopBar({ onMenuOpen }) {
  const { t } = useTranslation();
  const location = useLocation();
  const { user } = useAuthStore();

  // Derive current section label from URL.
  const sectionMap = {
    "/app/platform": t("platform.nav.overview"),
    "/app/platform/tenants": t("platform.nav.tenants"),
    "/app/platform/invitations": t("platform.nav.invitations"),
    "/app/platform/users": t("platform.nav.users"),
    "/app/platform/billing": t("platform.nav.billing"),
    "/app/platform/outbox": t("platform.nav.outbox"),
    "/app/platform/announcements": t("platform.nav.announcements"),
    "/app/platform/system": t("platform.nav.system"),
    "/app/platform/audit": t("platform.nav.audit"),
    "/app/platform/digest": t("platform.nav.digest"),
    "/app/platform/contact-statuses": "Kontak Statüleri",
    "/app/platform/deal-stages": "Fırsat Aşamaları",
    "/app/platform/templates": "Şablonlar",
  };
  const current = sectionMap[location.pathname] || t("platform.nav.overview");

  return (
    <header
      className="sticky top-0 z-20 border-b border-zinc-200 bg-white/85 backdrop-blur"
      data-testid="platform-topbar"
      style={{ paddingTop: "env(safe-area-inset-top)" }}
    >
      <div className="flex items-center gap-3 px-4 py-3 md:px-8">
      <button
        type="button"
        onClick={onMenuOpen}
        className="flex h-9 w-9 items-center justify-center rounded-full border border-zinc-200 text-zinc-600 transition-colors hover:border-zinc-300 hover:text-zinc-900 md:hidden"
        data-testid="platform-topbar-menu-btn"
        aria-label="Open menu"
      >
        <Menu className="h-4 w-4" />
      </button>

      <nav className="flex items-center gap-1.5 text-xs md:text-sm">
        <Link
          to="/app/platform"
          className="font-semibold text-zinc-500 hover:text-zinc-900"
          data-testid="platform-breadcrumb-root"
        >
          Serpix Admin
        </Link>
        <ChevronRight className="h-3.5 w-3.5 text-zinc-400" />
        <span className="font-semibold text-zinc-900" data-testid="platform-breadcrumb-current">
          {current}
        </span>
      </nav>

      <div className="ml-auto flex items-center gap-2 text-xs text-zinc-500">
        <span className="hidden md:inline">Signed in as</span>
        <span className="font-medium text-zinc-900">{user?.email}</span>
      </div>
      </div>
    </header>
  );
}
